import {
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { Edit as EditIcon, Delete as DeleteIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getCompetenceCategoriesWithoutDispatch } from 'shared/services/competenceCategoryService';
import { getCompetenceKindsWithoutDispatch } from 'shared/services/competenceKindService';
import {
  addCompetenceTemp,
  deleteCompetenceTemp,
  editCompetenceTemp,
  getCompetenceTempWithLimit,
} from 'shared/services/competenceTempService';
import { getCompetenceTypesWithoutDispatch } from 'shared/services/competenceTypeService';
import { getTempSkills } from 'shared/services/tempSkillService';
import { showSnackbarMessage } from 'shared/store/messages/actions';
import { getTableRowPerPageFromStorage } from 'shared/utils/localStorage';
import AddCompetenceForm from '../../../components/AddCompetenceForm/AddCompetenceForm';
import CustomDialog from '../../../components/CustomDialog/index';
import ConfirmationDialog from '../../../components/LayoutConfirmationDialog/LayoutConfirmationDialog';
import PageHeader from '../../../components/PageHeader';
import ElementsListAsync from '../../../components/list/ElementsListAsync';
import AdminSkillViewHead from '../AdminSkillView/AdminSkillViewHead';
import AdminCompetenceTempViewHead from './AdminCompetenceTempViewHead';

export class AdminCompetenceTempView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dictionariesKinds: [],
      dictionariesTypes: [],
      dictionariesCategories: [],
      dictionariesSkillsTemp: [],
      competenceTemps: [],
      competenceTempsCount: 0,
      order: 'asc',
      orderBy: 'id',
      deleteConfirmationOpened: false,
      openEditDialog: false,
      selectedCompetenceTemp: {},
      options: {
        limit: 12,
        offset: 0,
      },
      isClicked: false,
      isSubmitting: false,
    };
  }

  handleSorting = async (event, property) => {
    const orderBy = property;
    let order = 'asc';

    if (!orderBy) {
      return;
    }

    if (this.state.orderBy === property && this.state.order === 'asc') {
      order = 'desc';
    }

    await this.setState({ order, orderBy });
    this.handleReloadElements();
  };

  openRemoveDialog = competenceTemp => {
    this.setState({
      selectedCompetenceTemp: competenceTemp,
      deleteConfirmationOpened: true,
    });
  };

  handleRemove = async isOk => {
    if (isOk) {
      await deleteCompetenceTemp(this.state.selectedCompetenceTemp.id);
      this.handleReloadElements();
    }
    this.setState({
      deleteConfirmationOpened: false,
    });
  };

  onCloseEditDialog = () => {
    this.setState({
      selectedCompetenceTemp: null,
      openEditDialog: false,
    });
  };

  onOpenEditDialog = competenceTemp => {
    this.setState({
      selectedCompetenceTemp: competenceTemp,
      openEditDialog: true,
    });
  };

  handleUpdateCompetence = async values => {
    this.setState({
      isSubmitting: true,
    });
    const body = {
      competenceCategory: values.competenceCategory,
      competenceKind: values.competenceKind,
      competenceType: values.competenceType,
      skill: values.skill,
      isApproved: values.isApproved,
    };
    if (this.state.selectedCompetenceTemp) {
      editCompetenceTemp(this.state.selectedCompetenceTemp.id, body)
        .then(() => {
          this.onCloseEditDialog();
          this.handleReloadElements();
          this.props.showSnackbarMessage('Zapisano zmiany');
          this.setState({
            isSubmitting: false,
          });
        })
        .catch(error => {
          const { status } = error.response;
          if (status === 409) {
            this.props.showSnackbarMessage(
              'Podant rodzaj kompetencji istnieje w systemie'
            );
          }
          if (status === 418) {
            this.props.showSnackbarMessage(
              'Wszystkie wersje językowe składowe kompetencji, muszą zostać uzupełnione'
            );
          } else {
            this.props.showSnackbarMessage('Błąd podczas zapisu informacji');
          }
          this.setState({
            isSubmitting: false,
          });
        });
    } else {
      addCompetenceTemp(body)
        .then(() => {
          this.onCloseEditDialog();
          this.handleReloadElements();
          this.props.showSnackbarMessage('Zapisano zmiany');
          this.setState({
            isSubmitting: false,
          });
        })
        .catch(error => {
          const { status } = error.response;
          if (status === 409) {
            this.props.showSnackbarMessage(
              'Podant rodzaj kompetencji istnieje w systemie'
            );
          } else {
            this.props.showSnackbarMessage('Błąd podczas zapisu informacji');
          }
          this.setState({
            isSubmitting: false,
          });
        });
    }
  };

  loadData = async (options = {}) => {
    const { limit, offset, filters } = options || this.state.options;
    const limitToSearch = !limit
      ? getTableRowPerPageFromStorage(this.props.match.url) || 12
      : limit;
    const { order, orderBy } = this.state;
    this.setState({
      isLoading: true,
    });
    if (filters && filters.isApproved) {
      delete filters['isApproved'];
    }
    const params = {
      filters,
      orderBy: {
        [orderBy]: order,
      },
    };

    getCompetenceKindsWithoutDispatch().then(response => {
      const { data } = response;
      this.setState({
        dictionariesKinds: data,
      });
    });

    getCompetenceTypesWithoutDispatch().then(response => {
      const { data } = response;
      this.setState({
        dictionariesTypes: data,
      });
    });

    getCompetenceCategoriesWithoutDispatch().then(response => {
      const { data } = response;
      this.setState({
        dictionariesCategories: data,
      });
    });

    getTempSkills().then(response => {
      const { data } = response;
      this.setState({
        dictionariesSkillsTemp: data,
      });
    });

    getCompetenceTempWithLimit(limitToSearch, offset, params).then(response => {
      const { data } = response;
      this.setState({
        competenceTemps: data.data,
        competenceTempsCount: data.count,
      });
    });
    this.setState({
      isLoading: false,
    });
  };

  handleReloadElements = (options = false) => {
    if (options) {
      this.setState({
        options,
      });
    }
    if (!this.props.isLoading) {
      return this.loadData(options || this.state.options);
    } else {
      return null;
    }
  };

  componentWillMount() {
    this.handleReloadElements();
  }

  onOpenAddCompetence = () => {
    this.setState({
      selectedCompetenceTemp: null,
      openEditDialog: true,
    });
  };

  getWrapper = ({ content, filtering, pagination }) => {
    const { order, orderBy } = this.state;
    return (
      <Paper>
        <PageHeader title="Lista dostępnych kompetencji" />
        <Paper style={{ padding: 20 }} elevation={0}>
          {filtering}
        </Paper>
        <Button
          style={{ margin: '17px' }}
          onClick={() => this.onOpenAddCompetence()}
          variant="contained"
          color="primary"
        >
          Dodaj kompetencje
        </Button>
        <Table>
          <TableHead>
            <AdminCompetenceTempViewHead
              order={order}
              orderBy={orderBy}
              onRequestSort={this.handleSorting}
            />
          </TableHead>
          <TableBody>{content}</TableBody>
          <TableFooter>
            <AdminSkillViewHead
              order={order}
              orderBy={orderBy}
              onRequestSort={this.handleSorting}
            />
          </TableFooter>
        </Table>
        {pagination}
        <CustomDialog
          title={
            this.state.selectedCompetenceTemp
              ? 'Edycja kompetencji'
              : 'Dodaj kompetencje'
          }
          maxWidth={'lg'}
          isOpen={this.state.openEditDialog}
          onCloseDialog={this.onCloseEditDialog}
          body={
            <div
              style={{
                width: '600px',
              }}
            >
              <AddCompetenceForm
                dictionariesKinds={this.state.dictionariesKinds}
                dictionariesTypes={this.state.dictionariesTypes}
                dictionariesCategories={this.state.dictionariesCategories}
                dictionariesSkills={this.state.dictionariesSkillsTemp}
                competence={this.state.selectedCompetenceTemp}
                handleUpdateSkill={this.handleUpdateCompetence}
                isSubmitting={this.state.isSubmitting}
              />
              <Button onClick={this.onCloseEditDialog} color="primary">
                Zamknij
              </Button>
            </div>
          }
        />
        <ConfirmationDialog
          open={this.state.deleteConfirmationOpened}
          titleText="Usuń umiejętność?"
          onClose={this.handleRemove}
          okButtonText="Usuń"
          cancelButtonText="Anuluj"
        >
          Czy na pewno usunąć?
        </ConfirmationDialog>
      </Paper>
    );
  };

  getContent = competenceTemp => {
    return (
      <TableRow hover key={competenceTemp.id}>
        <TableCell align="right">{competenceTemp.id}</TableCell>
        <TableCell padding="none">
          {competenceTemp.competenceCategory.name}
        </TableCell>
        <TableCell padding="none">
          {competenceTemp.competenceKind.name}
        </TableCell>
        <TableCell padding="none">
          {competenceTemp.competenceType.name}
        </TableCell>
        <TableCell padding="none">{competenceTemp.skill.name}</TableCell>
        <TableCell padding="none">
          {competenceTemp.isApproved
            ? 'Zaakceptowany'
            : 'Oczekujący na akceptację'}
        </TableCell>
        <TableCell>
          <IconButton
            style={{ padding: 0 }}
            onClick={() => this.onOpenEditDialog(competenceTemp)}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            style={{ padding: 0 }}
            onClick={() => this.openRemoveDialog(competenceTemp)}
          >
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    );
  };

  render() {
    const { competenceTemps, competenceTempsCount } = this.state;
    const filteringOptions = [];

    return (
      <ElementsListAsync
        storageKey={this.props.match.url}
        rowsPerPage={getTableRowPerPageFromStorage(this.props.storageKey)}
        handleReloadElements={this.handleReloadElements}
        getContent={this.getContent}
        getWrapper={this.getWrapper}
        filteringOptions={filteringOptions}
        elements={competenceTemps || []}
        elementsCount={competenceTempsCount || 0}
        scrollUp={true}
      />
    );
  }
}

const mapDispatchToProps = {
  showSnackbarMessage,
};

AdminCompetenceTempView.propTypes = {
  order: PropTypes.string,
  orderBy: PropTypes.string,
  showSnackbarMessage: PropTypes.func.isRequired,
};
export default connect(null, mapDispatchToProps)(AdminCompetenceTempView);
